import { ReactNode } from "react"
import { Box } from "@material-ui/core"

export function ContentLayout({
  children,
  maxHeight,
  customClass,
}: {
  children: ReactNode
  maxHeight: string
  customClass?: string
}) {
  return (
    <Box maxHeight={maxHeight} className={customClass}>
      {children}
    </Box>
  )
}
